import { orderedDimensions } from '@upright/common/model/types';
import { theme } from '@upright/ui/assets/styles/tokens';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { compact } from 'lodash';
import { useCarouselContext, useCarouselLayout } from '../context';

export function HorizontalLines() {
  const layout = useCarouselLayout();
  const dataAreaLeft = layout.dataArea(Side.LEFT);
  const dataAreaRight = layout.dataArea(Side.RIGHT);
  const descriptionsArea = layout.topDescriptionsArea();
  const fullArea = layout.fullArea();
  const x1 = dataAreaLeft.x2;
  const x2 = dataAreaRight.x1;
  const width = x2 - x1;

  // TODO: cleanup
  const stroke = 'transparent';
  const dimensionSeparatorLines = compact(
    orderedDimensions.slice(0, 3).map((dimension, index) => {
      if (index !== 0) {
        return undefined;
      }
      const dimensionArea = layout.dimensionArea(dimension);
      const y = dimensionArea.y2;
      return <rect key={dimension} x={x1} y={y} width={width} height={1} fill={stroke} />;
      // return <line x1={x1} x2={x2} y1={y} y2={y} stroke={stroke} />;
    }),
  );

  const showTopHorizontalLine = !useCarouselContext().options.hideTopDescriptionArea;

  return (
    <g>
      {showTopHorizontalLine && (
        <line
          data-top-rule
          x1={fullArea.x1}
          x2={fullArea.x2}
          y1={descriptionsArea.y1}
          y2={descriptionsArea.y1}
          stroke={theme.color['gray-300']}
        />
      )}
      <rect x={x1} y={dataAreaLeft.y1} width={width} height={1} fill={theme.color['gray-300']} />
      {dimensionSeparatorLines}
    </g>
  );
}
